export default __webpack_public_path__ + "static/media/reaction-04.6350f4c6.svg";